// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".register-terms-and-conditions--actions {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 10px;\n  margin-top: auto;\n  width: 100%; }\n\n.register-terms-and-conditions--text {\n  overflow-y: scroll;\n  height: 300px;\n  margin-bottom: 38px;\n  margin-top: 15px; }\n", ""]);
// Exports
module.exports = exports;
